import React, {Component, ReactNode} from 'react';
import {observer} from "mobx-react";
import {Criterion} from "../../domain/criterion/criterionDomain";
import TextField from "material-ui/TextField";
import {SubCriterionParameter, VALUETYPE} from "../../domain/criterion/subCriterionParameterDomain";
import StyledSelect from "../../../core/components/fields/styledSelect";
import {fieldStyles} from "../../../core/form/createForm";
import {PERMISSION} from "../../../core/metamodel/metaConstant";
import {ZzFlatButton} from "../../../core/components/buttons/buttons";
import {Table, TableBody, TableRow, TableRowColumn} from "material-ui";
import sbToolParamsService from "../../service/paramsService";
import {action, observable} from "mobx";
import {ProjectVersionParamValue} from "../../domain/project/projectVersionParameterValueDomain";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {loc} from "../../../core/common/config/locales";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface State {
}

interface Props {
  criterion: Criterion
  handleChangeValueState: (bool: boolean) => void

}

const addDeleteColumnStyle = {
  width: "80px"
};

@observer
class ParametersComplexCriterionForm extends Component<Props, State> {

  private readonly SHARED_PARAM_NUMBER = 1;
  private newParameter = observable.map<string>();
  private parameterRows = observable([]);
  private errors = observable.map<string>();


  private getParameters = () => {
    const {criterion} = this.props;
    const subCriteria = criterion.subCriteria;
    const parameters: SubCriterionParameter[] = [];
    subCriteria.forEach(subCriterion => (subCriterion.parameters.forEach(param => (parameters.push(param)))));
    const nonSharedParams = parameters.filter(param => (param.number !== this.SHARED_PARAM_NUMBER));
    const sharedParam = subCriteria[0].parameters.filter(param => (param.number === this.SHARED_PARAM_NUMBER))[0];
    const sharedParamId = sharedParam.paramId;
    return {'nonSharedParams': nonSharedParams, 'sharedParam': sharedParam, 'sharedParamId': sharedParamId};
  };


  componentDidMount(): void {
    console.warn('componentDidMount')
    this.parameterRows.clear()
    this.fillParameterRows()

    const {nonSharedParams, sharedParamId} = this.getParameters();
    this.newParameter.set(sharedParamId.toString(), '');
    nonSharedParams.forEach(param => {
      this.newParameter.set(param.paramId.toString(), '')
    });
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any) {
    if (prevProps.criterion !== this.props.criterion) {
      console.warn('componentDidUpdate')

      this.parameterRows.clear()
      this.newParameter.clear()
      const {nonSharedParams, sharedParamId} = this.getParameters();
      this.newParameter.set(sharedParamId.toString(), '');
      nonSharedParams.forEach(param => {
        this.newParameter.set(param.paramId.toString(), '')
      });
      this.fillParameterRows()
    }
  }

  componentWillUnmount() {
    this.parameterRows.clear()
    this.newParameter.clear()
  }

  private isValidRow = (): boolean => {
    this.errors.clear();
    this.newParameter.keys().forEach(key => {
      let value: string = this.newParameter.get(key).toString();
      if (value.trim().length === 0) {
        this.errors.set(key, loc.i18n`Parameter is empty`);
      }
    });

    const {sharedParamId} = this.getParameters();
    const sharedParamValue = this.newParameter.get(sharedParamId.toString());
    sbToolParamsService.paramsValues.filter(param => (param.paramNumber === this.SHARED_PARAM_NUMBER)).forEach(param => {
      if (param.value.toString().trim() === sharedParamValue) {
        this.errors.set(sharedParamId.toString(), loc.i18n`Parameter must be entered only once`);
      }
    });

    return this.errors.size === 0;
  };

  private onChangeValue = (paramId: number, value: string): void => {
    const valueMap = this.newParameter;
    valueMap.set(paramId.toString(), value);
    this.newParameter.replace(valueMap);
  };

  private onDelete = (paramNumber: number): void => {
    let filteredParameterRows = this.parameterRows.filter((element, index) => (index + 1 !== paramNumber));
    let filteredParams = sbToolParamsService.paramsValues.filter(paramValue => (paramValue.paramNumber !== paramNumber));
    filteredParams.forEach(param => {
      if (param.paramNumber > paramNumber) {
        param.paramNumber -= 1;
      }
    });
    sbToolParamsService.paramsValues.replace(filteredParams);
    this.parameterRows.replace(filteredParameterRows);
    this.props.handleChangeValueState(true)

  };

  private onAddValue = () => {
    if (!this.isValidRow()) {
      console.warn('ROW IS NOT VALID', this.errors)
      return;
    }

    const keys = this.newParameter.keys(); //KEYS ARE PARAM ID
    const {criterion} = this.props;
    const subCriteria = criterion.subCriteria;
    subCriteria.forEach(subCriterion => {
      subCriterion.parameters.forEach(parameter => {
        let param: ProjectVersionParamValue;
        if (parameter.number === this.SHARED_PARAM_NUMBER) {
          const sharedParam = subCriterion.parameters;
          const sharedParamId = sharedParam[0].paramId;

          const sharedParamValue = this.newParameter.get(sharedParamId.toString());
          param = new ProjectVersionParamValue({
            value: sharedParamValue,
            paramNumber: this.parameterRows.length + 1,
            projectVersion: SbToolProjectVersionService.projectVersion,
            parameter: parameter,
            count: 1,
            $new: true
          });

        } else {
          let paramValueKey = null;
          for (let i = 0; i < keys.length; i++) {
            if (parameter.paramId.toString().includes(keys[i])) {
              paramValueKey = keys[i];
            }
          }
          if (paramValueKey === null) {
            return;
          }

          const paramValue = this.newParameter.get(paramValueKey);
          param = new ProjectVersionParamValue({
            value: paramValue,
            paramNumber: this.parameterRows.length + 1,
            projectVersion: SbToolProjectVersionService.projectVersion,
            parameter: parameter,
            count: 1,
            $new: true
          });

        }
        param.initAfterRead(true);
        sbToolParamsService.paramsValues.push(param);
      });
      this.props.handleChangeValueState(true)

    });

    const paramValueMap = new Map();
    this.newParameter.keys().forEach(key => (paramValueMap.set(key, this.newParameter.get(key))));
    this.parameterRows.push(paramValueMap);
    const cleanRow = observable.map<string>();
    this.newParameter.keys().forEach(key => (cleanRow.set(key, '')));
    this.newParameter = cleanRow;
  };

  private renderAddRow = (): ReactNode => {
    const {criterion} = this.props;
    const subCriteria = criterion.subCriteria;

    if (subCriteria.length === 0) {
      return <noscript/>
    }

    let params: SubCriterionParameter[] = [];
    for (let subcrioterion of criterion.subCriteria) {
      for (let param of subcrioterion.parameters) {
        params.push(param);
      }
    }

    return (
      <div style={{display: "flex", height: 60, width: '100%'}}>
        {params.map(parameter => {
            if (parameter.valueType === VALUETYPE.NUMBER) {
              return (
                <TextField
                  {...fieldStyles.small.textField}
                  key={parameter.paramId}
                  type="string"
                  style={{flexGrow: 1}}
                  value={this.newParameter.get(parameter.paramId.toString())}
                  onChange={e => {
                    this.onChangeValue(parameter.paramId, e.target.value)
                  }}
                  floatingLabelText={parameter.name}
                  errorText={this.errors.get(parameter.paramId.toString())}
                />
              );
            } else if (parameter.valueType === VALUETYPE.PARAM_ID) {
              const options = parameter.parameters
                .sort((p1, p2) => p1.value - p2.value)
                .map(p => {
                  return {label: p.label + " (" + p.value + ")", value: p.valueId}
                });
              return (
                <StyledSelect
                  {...fieldStyles.small.styledSelect}
                  label={parameter.name}
                  value={this.newParameter.get(parameter.paramId.toString())}
                  onChange={e => {
                    this.onChangeValue(parameter.paramId, e.value)
                  }}
                  floatingLabelText={parameter.name}
                  key={parameter.paramId}
                  options={options}
                  asterixForAll={false}
                  style={{flexGrow: 1}}
                  async={false}
                  searchable={true}
                  clearable={false}
                  errorText={this.errors.get(parameter.paramId.toString())}
                />
              );
            }
          }
        )}

        <ZzFlatButton onClick={() => this.onAddValue()} permission={PERMISSION.Update} style={addDeleteColumnStyle}>
          <i className="fa fa-plus" aria-hidden="true"/>
        </ZzFlatButton>

      </div>
    );
  };

  private renderTableBody = (): ReactNode => {
    return (
      <TableBody displayRowCheckbox={false}>
        {this.renderRows()}
      </TableBody>
    )
  };

  @action
  private fillParameterRows = () => {
    if (!sbToolParamsService.parametersLoaded) {
      setTimeout(this.fillParameterRows, 1000);
      return;
    }
    //all params that was saved
    const params = sbToolParamsService.paramsValues;
    if (params.length === 0) {
      // console.warn("CRITERIA HAS NO FILLED PARAMS")
      return
    }
    // detecting how much subCriterion is for count columns
    const rowLength = this.props.criterion.subCriteria.length
    //will be fulfilled by {id:value} of param
    const fullParam = new Map()
    params.forEach((param, index) => {
      const paramId = param.parameter.paramId;
      const value = param.value
      fullParam.set(paramId, value);
      // divide params by subCriteria length for 1 row
      if ((index + 1) % rowLength === 0) {
        this.parameterRows.push(fullParam);
        fullParam.clear()
      }
    })
  };

  private renderRows = (): ReactNode[] => {

    const {criterion} = this.props;
    const subCriteria = criterion.subCriteria;
    const params = sbToolParamsService.paramsValues;
    if (params.length === 0) {
      return [];
    }

    const rows = [];
    for (let i = 0; i < this.parameterRows.length; i++) {
      if (this.parameterRows[i].size === 0) {
        return
      }
      let columns = [];
      let valueMap = this.parameterRows[i];

      subCriteria.forEach(subCriterion => {
        subCriterion.parameters.forEach(parameter => {
          valueMap.keys().forEach(key => {
            if (key == parameter.paramId) {
              let value = valueMap.get(key);
              if (parameter.valueType === VALUETYPE.PARAM_ID) {
                let labelParameter = parameter.parameters.find(param => (param.valueId === Number(value)));
                value = labelParameter.label;
              }
              columns.push(<OverlayTrigger
                placement="left"
                key={i}
                overlay={
                  <Tooltip
                    id="valueTooltip"
                    style={{fontSize: 13}}
                    className="left-aligned-tooltip"
                  >
                    {value}
                  </Tooltip>
                }>
                <TableRowColumn key={i + '' + key}>{value}</TableRowColumn>
              </OverlayTrigger>);
            }
          });
        });
      });
      columns.push(this.renderDeleteColumn(i + 1));
      rows.push(<TableRow key={i}>{columns}</TableRow>);

    }
    return rows;
  };

  private renderDeleteColumn = (paramNumber: number) => {
    return (
      <TableRowColumn key={paramNumber + ' delete'} style={addDeleteColumnStyle}>
        <ZzFlatButton onClick={() => this.onDelete(paramNumber)} permission={PERMISSION.Update}>
          <i className="fa fa-minus" aria-hidden="true"/>
        </ZzFlatButton>
      </TableRowColumn>
    )
  };

  render(): JSX.Element | false | null {
    return (
      <div style={{marginTop: 20, width: "100%"}}>
        {this.renderAddRow()}
        <Table selectable={false}>
          {this.renderTableBody()}
        </Table>
      </div>
    );
  }
}

export default ParametersComplexCriterionForm;



// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/parametersComplexCriterionForm.tsx